
import $ from "jquery"
import { EventEmitter } from "events"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"


interface Selector {
  scope:                  string | JQuery
  main:                   string | JQuery
  menu:                   string | JQuery
  button:                 string | JQuery
  selected_text:          string | JQuery
  selector:               string | JQuery
  category_selector_item: string | JQuery
}
interface InputSelector {
  scope?:                  string | JQuery
  main?:                   string | JQuery
  menu?:                   string | JQuery
  button?:                 string | JQuery
  selected_text?:          string | JQuery
  selector?:               string | JQuery
  category_selector_item?: string | JQuery
}
const DEFAULT_SELECTOR = {
  scope:                  ".cell--buildings--overseas-marketing--filter",
  main:                   ".cell--buildings--overseas-marketing--filter--form__categories",
  menu:                   ".cell--buildings--overseas-marketing--filter--form__categories--menu",
  button:                 ".cell--buildings--overseas-marketing--filter--form__categories--button",
  selected_text:          ".cell--buildings--overseas-marketing--filter--form--selected--text",
  selector:               ".cell--buildings--overseas-marketing--filter--form__categories-selector",
  category_selector_item: ".cell--buildings--overseas-marketing--filter--form__categories-selector-item",
}


export class CategoriesSelector extends EventEmitter {
  protected selector: Selector
  protected $scope: JQuery
  protected $el: JQuery
  protected $button: JQuery
  protected $menu: JQuery
  protected $selector: JQuery
  protected $selected_text: JQuery
  protected $category_selector_item: JQuery

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)
    this.$button = this.$el.find(this.selector.button)
    this.$menu = this.$el.find(this.selector.menu)
    this.$selector = this.$el.find(this.selector.selector)
    this.$selected_text = this.$el.find(this.selector.selected_text)
    this.$category_selector_item = this.$el.find(this.selector.category_selector_item)

    this.bind_action()
    this.created()
  }

  public getSelectedText(){
    return this.getSelectedItem().parents(".radio").find("label").text()
  }
  public getSelectedValue(){
    return this.getSelectedItem().val()
  }

  public isDefault(): boolean {
    return this.getSelectedValue() === "new_developments"
  }

  public reset(): void {
    this.$el.find("input[type=radio]:radio[value=new_developments]").prop("checked", true)
    this.updateSelectedText()
  }

  protected onClick(): void {
    this.toggle()
  }
  protected toggle(){
    if (this.$menu.is(":visible")){
      this.close()
    }
    else{
      this.open()
    }
    return this
  }
  protected open(){
    this.$menu.show()
    return this
  }
  protected close(){
    this.$menu.hide()
    return this
  }
  protected onClickout(){
    this.close()
  }
  protected getSelectedItem(){
    return this.$category_selector_item.filter(":checked")
  }
  protected updateSelectedText(){
    this.$selected_text.text(this.getSelectedText())
  }
  protected bind_action(){
    this.$button.on("click", () => {
      this.onClick()
    })

    this.$selector.on("change", () => {
      this.updateSelectedText()
      this.onClickout()
      this.emit("val_change")
    })

    onClickOutside(this.$el[0] as HTMLElement, () => {
      this.onClickout()
    })
  }
  protected created(){
    this.updateSelectedText()
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new CategoriesSelector(selector)
  },
}

export {
  Factory,
}
